/* © Facilogi. See COPYRIGHT file for full copyright & licensing details. */

export default {
    CONSOLE_USERS_title: "Console users",
    CONSOLE_USERS_label: "user",
    CONSOLE_USERS_plural_label: "users",
    CONSOLE_USERS_back: "Back to users",

    CONSOLE_USERS_columnName: "Name",
    CONSOLE_USERS_columnEmail: "Email",
    CONSOLE_USERS_columnPhone: "Phone",
    CONSOLE_USERS_columnRole: "Role",
    CONSOLE_USERS_columnState: "State",

    CONSOLE_USERS_invite: "Create a user",
    CONSOLE_USERS_inviteTitle: "Create a user",
    CONSOLE_USERS_confirmInvite: "Create user",

    CONSOLE_USERS_fieldFirstName: "First name",
    CONSOLE_USERS_fieldFirstNamePlaceholder: "e.g. Mary",
    CONSOLE_USERS_fieldLastName: "Last name",
    CONSOLE_USERS_fieldLastNamePlaceholder: "e.g. Smith",
    CONSOLE_USERS_fieldEmail: "Email",
    CONSOLE_USERS_fieldEmailPlaceholder: "mary.smith@facilogi.com",
    CONSOLE_USERS_fieldPhone: "Phone",
    CONSOLE_USERS_fieldPhonePlaceholder: "+33 6 12 34 56 78",
    CONSOLE_USERS_fieldPassword: "Password",
    CONSOLE_USERS_fieldPasswordPlaceholder: "User's password",
    CONSOLE_USERS_passwordHint: "At least 9 characters, with uppercase, lowercase and a digit. "
        + "Share it with the user. They will set up two-factor authentication on first login.",
    CONSOLE_USERS_inviteEmailHint: "The user will receive an email with a link to activate their "
        + "account and set their password. They will set up two-factor authentication on first "
        + "sign in.",
    CONSOLE_USERS_fieldRole: "Role",
    CONSOLE_USERS_rolePlaceholder: "Select a role",
    CONSOLE_USERS_noRole: "No role",

    CONSOLE_USERS_filterState: "State",
    CONSOLE_USERS_filterStatePlaceholder: "Filter by state",
    CONSOLE_USERS_stateActive: "Active",
    CONSOLE_USERS_statePending: "Pending",
    CONSOLE_USERS_stateDisabled: "Disabled",

    CONSOLE_USERS_inviteSuccessTitle: "Invitation sent",
    CONSOLE_USERS_inviteSuccessMessage: "An activation email has been sent to the user.",

    CONSOLE_USERS_detailTitle: "User detail",
    CONSOLE_USERS_sectionInfo: "Information",
    CONSOLE_USERS_sectionRole: "Role and privileges",
    CONSOLE_USERS_pendingNotice: "This user has not activated their account yet.",

    CONSOLE_USERS_actionDisable: "Disable",
    CONSOLE_USERS_actionReactivate: "Reactivate",
    CONSOLE_USERS_actionReinvite: "Resend invitation",
    CONSOLE_USERS_actionAssignRole: "Assign role",
    CONSOLE_USERS_edited: "Information updated.",
    CONSOLE_USERS_formChanged: "No changes | You changed 1 user field | " +
        "You changed {count} user fields",

    CONSOLE_USERS_disableConfirm: "Are you sure you want to disable this user?" +
        " They will no longer be able to sign in to the Console.",
    CONSOLE_USERS_disabled: "User disabled.",
    CONSOLE_USERS_reactivated: "User reactivated.",
    CONSOLE_USERS_reinvited: "Invitation resent.",
    CONSOLE_USERS_roleAssigned: "Role assigned.",

    CONSOLE_USERS_accountDisabled: "This account is disabled.",
    CONSOLE_USERS_cannotDisableSuperAdmin: "A Super Admin cannot be disabled.",
    CONSOLE_USERS_superAdminRoleLocked: "A Super Admin's role cannot be changed.",
    CONSOLE_USERS_invalidInvitation: "This invitation is invalid or has already been used.",

    CONSOLE_USERS_splashScreenTitle: "Invite your first user",
    CONSOLE_USERS_splashScreenDescription: "Console users are the members of your team " +
        "who access the Console."
};
